












import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
    components: {},
})
export default class NavDropdown extends Vue {
    @Prop({default: () => []})
    public items!: any[];
    @Prop({default: ''})
    public text!: string;
    @Prop({default: ''})
    public rootPath!: string;
}
